import React, { useEffect, useState } from "react";

export default function les5_1() {
  const [Count, setCount] = useState(5);
  useEffect(() => {
    document.title = `Doc5_1 : ${Count}`;
    return () => {
      document.title = `Hide effect`;
    };
  }, [Count]);
  return (
    <div>
      <button
        onClick={(e) => {
          e.preventDefault();
          setCount(Count + 8);
        }}
      >
        Count
      </button>
    </div>
  );
}



// WEBPACK FOOTER //
// src/page/les5-1.js